const testimonialBlocks = Array.from(document.querySelectorAll('.testimonials'));

testimonialBlocks.forEach(testimonialBlock => {
    const testimonialNav = testimonialBlock.querySelector('.testimonials__nav');
    const testimonials = testimonialBlock.querySelectorAll('.testimonial');
    if (!testimonialNav) return;
    testimonialNav.addEventListener('click', e => {
        const button = e.target;
        const targetedTestimonialId = button.getAttribute('aria-controls');
        if (!targetedTestimonialId) return;
        testimonials.forEach(testimonialEl => {
            if (testimonialEl.id === targetedTestimonialId) {
                testimonialEl.hidden = false;
                button.setAttribute('aria-expanded', 'true');
            } else {
                testimonialEl.hidden = true;
                const testimonialElButton = testimonialBlock.querySelector(`[aria-controls="${testimonialEl.id}"]`);
                if (testimonialElButton) testimonialElButton.setAttribute('aria-expanded', 'false');
            }
        });
    });
});

